import { reportStolenContainerDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getreportStolenContainerEn = () => {
  const data = reportStolenContainerDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addreportStolenContainer = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-report-a-lost-or-stolen-container`,
    ) &&
    document.getElementById(`reportStolenContainerJSONLD`) === null
  ) {
    const script = reportStolenContainerJSONLDEn()
    addJSONLDToHead(script, `reportStolenContainerJSONLD`)
  } else {
    removeElement(`reportStolenContainerJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const reportStolenContainerJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getreportStolenContainerEn(),
  }
  return FaqBagsterTemplate
}
